import * as React from 'react'
function SvgArrowLeft(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M18.8 32a1.98 1.98 0 000-2.8L11.6 22H34a2 2 0 100-4H11.6l7.2-7.2A1.98 1.98 0 0016 8L5.414 18.586a2 2 0 000 2.828L16 32a1.98 1.98 0 002.8 0z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgArrowLeft
